/*
Author: Rendra Pramulia
Description: Custom react hooks for handle API request
*/

import { useState } from 'react';

const useApi = (apiFunc) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const request = async (...args) => {
    setLoading(true);
    setData([]);
    setError(false);

    try {
      const response = await apiFunc(...args);
      setLoading(false);
      setError(false);
      setData((response.data && response.data.data) || null);
      return response;
    } catch (error) {
      setError(true);
      setLoading(false);
      return { success: false, data: null };
    }
  };

  const updateData = (datas) => {
    setData(datas);
    setError(false);
    setLoading(false);
  };

  return { data, error, loading, request, updateData };
};

export default useApi;
